<template>
  <div>
    <div>
      <el-form ref="form" :rules="rules" :model="form" label-width="110px">
        <el-card shadow="never" header="过期提醒">
          <label style="margin-left: 37px;color: red;">备注：资质目前默认30天到期时间</label>
          <el-form-item> </el-form-item>
          <el-form-item> </el-form-item>
          <el-form-item> </el-form-item>
          <el-form-item label="默认" style="margin-left: 3px;">
            <el-radio-group>
              <el-radio>30天</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-card>
        </el-form>
        <imgPicker
        :dialog-visible="imgDialog"
        :sc-status="isGetImage"
        @chooseImg="pickImg"
        @closeImgDialog="closeImgDialog"
      ></imgPicker>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import imgPicker from "@/components/imageselect";
import draggable from "vuedraggable";
export default {
   components: { imgPicker, draggable },
  data() {
    return {
      pickerImgType: "",
      imgDialog: false,
      isGetImage: false,
      dialogFormVisible: false,
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
      },
      form: {
        discount_again:1
      },
      dataList: [],
      typeList:[],
      loading: false,
      id: "",
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    getMerchantCredentialTypesList(){
      getMerchantCredentialTypes().then((res)=>{
          this.typeList=res.data.data.list
      })
    },
    toAdd() {
      this.form=[];
      this.dialogFormVisible = true;
      this.getMerchantCredentialTypesList()
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.getMerchantCredentialTypesList();
      this.form= row;
      this.id = row.id;
    },
    onSubmit(formName) {
      var submit = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log("error submit!!");
          return false;
        } else {
          submit = true;
        }
      });
      if (submit == false) {
        return;
      }
      var that = this;
      if (this.id) {
        editMerchantCredentials(this.id, this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
            setTimeout(function () {
              that.params.page = 1;
              that.getDataList();
            }, 1000);
          } else {
            this.$message.error("修改失败!");
            return false;
          }
        });
      } else {
        addMerchantCredentials(this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "保存成功",
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
            setTimeout(function () {
              that.params.page = 1;
              that.getDataList();
            }, 1000);
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
      }
    },
    del(id, index) {
      var that = this;
      this.$confirm("确定要删除该商品？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMerchantCredentials(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      getMerchantCredentials(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
     pickImg(data) {
      this.form[this.pickerImgType] = data.url;
      this.imgDialog = false;
    },
    handleImgPicker(pickerImgType) {
      this.pickerImgType = pickerImgType;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    closeImgDialog() {
      this.imgDialog = false;
      this.isGetImage = false;
    },
  },
  mounted() {
    // this.getDataList();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// noticeset.vue?04c878ed